// extracted by mini-css-extract-plugin
export var actions = "_6y-8";
export var arrow = "_6y-5";
export var card = "_6y-0";
export var cardWrapper = "_6y-9";
export var fieldName = "_6y-3";
export var newValue = "_6y-6";
export var oldValue = "_6y-4";
export var orangeGlowFade = "_6y-c";
export var productSection = "_6y-1";
export var scrollToBottom = "_6y-b";
export var scrollToBottomAnchor = "_6y-a";
export var scrollToBottomIcon = "_6y-d";
export var showAllButton = "_6y-7";
export var table = "_6y-2";